import { Button } from '@components'
import styled from 'styled-components'

export const FormStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}rem;
  min-width: 0;
`

export const TargetRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}rem;
`

export const TargetLabel = styled.span`
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.metalGray};
  white-space: nowrap;
`

export const TargetSelect = styled.div`
  flex: 1;
  min-width: 0;

  select {
    font-weight: 600;
  }
`

export const ConditionsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}rem;
`

export const ConnectorRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs}rem;
`

export const ConnectorRule = styled.div`
  flex: 1;
  height: 1px;
  background: ${({ theme }) => theme.colors.neutralGray};

  &:first-child {
    max-width: 14px;
    flex: 0 0 14px;
  }
`

export const ConnectorChip = styled(Button)`
  flex-shrink: 0;
`

export const ConditionEntry = styled.div`
  &:hover button[aria-label],
  &:focus-within button[aria-label] {
    opacity: 1;
  }
`

export const ConditionCard = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.xs}rem;
  padding: ${({ theme }) => theme.spacing.sm}rem;
  border: 1px solid ${({ theme }) => theme.colors.neutralGray};
  border-radius: ${({ theme }) => theme.borderRadius.sm}rem;
  background: ${({ theme }) => theme.colors.neutralWhite};
`

export const ConditionBody = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}rem;
`

export const BooleanControlRow = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.xs}rem;
`

export const DatetimeControlRow = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: ${({ theme }) => theme.spacing.xs}rem;
`

export const FieldSelect = styled.div`
  flex: 1 1 100%;
  min-width: 0;
`

export const ValueControl = styled.div`
  flex: 1 1 130px;
  min-width: 0;
`

export const StackedValue = styled.div`
  min-width: 0;
`

export const FieldLabel = styled.span`
  color: ${({ theme }) => theme.colors.metalGray};
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
  font-weight: 600;
  align-self: center;
`

export const TrailingWord = styled.span`
  color: ${({ theme }) => theme.colors.iconGray};
`

export const AmountError = styled.span`
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  color: ${({ theme }) => theme.colors.error};
`

export const Footnote = styled.div`
  display: flex;
  gap: 6px;
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  line-height: 1.45;
  color: ${({ theme }) => theme.colors.iconGray};
`

export const FootnoteIcon = styled.span`
  flex-shrink: 0;
  margin-top: 2px;
  font-size: 11px;
  color: ${({ theme }) => theme.colors.borderStrong};

  svg {
    width: 11px;
    height: 11px;
  }
`

export const RemoveButton = styled(Button)`
  flex-shrink: 0;
  opacity: 0;
`

export const AddButtonRow = styled.div`
  display: flex;
`

export const StatusText = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
  color: ${({ theme }) => theme.colors.iconGray};
`

export const HintText = styled(StatusText)`
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
`

export const ErrorBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}rem;
`
